import { LegLocation } from '@api/Trinium/Endpoints/Leg/types';

import styles from './Form.module.css';

interface LocationButtonContentProps {
	location?: LegLocation;
	emptyValueText: string;
}

export default function LocationButtonContent({ location, emptyValueText }: LocationButtonContentProps) {
	if (!location || !location.id) {
		return <span>{emptyValueText}</span>;
	}

	if (!location.name) {
		return (
			<div>
				<span>{`(${location.id})`}</span>
			</div>
		);
	}

	return (
		<div className={styles['loc-btn']}>
			<span className={styles['loc-btn-name']}>{location.name}</span>
			<span> {`(${location.id})`}</span>
		</div>
	);
}
